exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example highlight when a scenario is active */\n.active[data-v-7e34db6b] {\n  border: 1px solid #085FCE !important;\n  box-shadow: 0 0 3px #085FCE;\n}\ntable th[data-v-7e34db6b],\ntd[data-v-7e34db6b] {\n  padding-left: 22px !important;\n}", ""]);

// exports
